import {Component, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-onboarding-hint",
    templateUrl: "./onboarding-hint.component.html",
    styleUrls: ["./onboarding-hint.component.scss"],
})
export class CmOnboardingHintComponent {}
